import React from 'react';

import { IconButton } from '@mui/material';

import styles from 'components/common/CloseButton/CloseButton.module.scss';

export const CloseButton = ({ onClick }) => {
    return (
        <IconButton className={styles.closeButton} onClick={onClick} aria-label={'close'}>
            <svg width={'20'} height={'20'} viewBox={'0 0 20 20'} fill={'none'}>
                <path
                    d={'M15 5L5 15M5 5L15 15'}
                    stroke={'currentColor'}
                    strokeWidth={'2'}
                    strokeLinecap={'round'}
                    strokeLinejoin={'round'}
                />
            </svg>
        </IconButton>
    );
};
